import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { SuperAssociationsPage } from '@/pages/admin/SuperAssociationsPage';

export function ProjectAssociationsPage() {
  const { projectId } = useParams<{ projectId: string }>();

  const pid = useMemo(() => {
    const n = parseInt(String(projectId ?? ''), 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  }, [projectId]);

  if (!pid) {
    return <div className="p-6 text-sm text-red-600">projectId invalide</div>;
  }

  return <SuperAssociationsPage forcedProjectId={pid} />;
}

